import React, { useContext } from 'react';
import { ImFacebook, ImPinterest, ImInstagram, ImYoutube } from 'react-icons/im'
import { CursorContext } from '../context/CursorContext';


const Socials = () => {

  const {mouseEnterHandler, mouseLeaveHandler} = useContext(CursorContext)

  return <div onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler} className='hidden xl:flex ml-24'>
    <ul className='flex gap-x-4'>
      <li>
        <a href='https://www.facebook.com' target='_blank' rel='noreferrer' className='text-[#696c6d] hover:text-primary transition-colors duration-300 text-xl'><ImFacebook /></a>
      </li>
      <li>
        <a href='https://www.pintrest.com' target='_blank' rel='noreferrer' className='text-[#696c6d] hover:text-primary transition-colors duration-300 text-xl'><ImPinterest /></a>
      </li>
      <li>
        <a href='https://www.instagram.com' target='_blank' rel='noreferrer' className='text-[#696c6d] hover:text-primary transition-colors duration-300 text-xl'><ImInstagram /></a>
      </li>
      <li>
        <a href='https://www.youtube.com' target='_blank' rel='noreferrer' className='text-[#696c6d] hover:text-primary transition-colors duration-300 text-xl'><ImYoutube /></a>
      </li>
    </ul>
  </div>;
};

export default Socials;
